export { default } from './styled';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/styled/index.js
// module id = 914
// module chunks = 2